import { functions } from "@/plugins/firebase";
import { AbstractAdapter } from "@/adapter/abstractAdapter";
import {
  setGuestApi,
  getGuestDetailInfoApi,
  getGuestPaymentInfoApi,
  getGuestListApi,
} from "@/helper/functions";
import { IGuest } from "@/types/guest";
import { httpsCallable } from "firebase/functions";
export class GuestApi extends AbstractAdapter {
  async getGuestList(): Promise<any> {
    this.startLoading();
    const getGuestListFunc = httpsCallable(functions, getGuestListApi);
    try {
      return await getGuestListFunc();
    } finally {
      this.finishLoading();
    }
  }

  async getUserInfo(isLoading = true): Promise<any> {
    if (isLoading) {
      this.startLoading();
    }
    const getGuestDetailInfoFunc = httpsCallable(
      functions,
      getGuestDetailInfoApi
    );
    try {
      return await getGuestDetailInfoFunc({});
    } finally {
      if (isLoading) {
        this.finishLoading();
      }
    }
  }

  async getPaymentInfo(): Promise<any> {
    this.startLoading();

    const getPaymentInfoFunc = httpsCallable(functions, getGuestPaymentInfoApi);
    try {
      return await getPaymentInfoFunc({});
    } finally {
      this.finishLoading();
    }
  }

  async setGuestData(guestData: Partial<IGuest>): Promise<void> {
    this.startLoading();

    // 登録している書籍の詳細情報取得
    const setGuestFunc = httpsCallable(functions, setGuestApi);
    try {
      await setGuestFunc({ guestData: guestData });
    } finally {
      this.finishLoading();
    }
  }
}
